/**
 * A video's still, the way the Learn page takes them: a Mux frame a few
 * seconds in (past the fade up from black), smartcropped to the box, and
 * the gym photo when there is no video or the frame fails to load.
 *
 * `dim` is Learn's treatment for a still with words over it: the frame
 * sits at half strength so a rough one reads as texture behind the title
 * rather than as the picture, and comes up on hover (bam-learn-dim).
 */
import React, { useEffect, useState } from "react";
import { muxFrame } from "../masterclass/coverArt";

export const THUMB_FALLBACK = "/images/learn/gym-flags.jpg";

/** The frames to try, best first. */
export function thumbSrcs(playbackId, { width = 480, height = 270 } = {}) {
  return [muxFrame(playbackId, { width, height, time: 3 }), THUMB_FALLBACK].filter(Boolean);
}

export function VideoThumb({ playbackId, width, height, dim = false, style }) {
  const srcs = thumbSrcs(playbackId, { width, height });
  const key = srcs.join("|");
  const [i, setI] = useState(0);
  useEffect(() => { setI(0); }, [key]);
  if (i >= srcs.length) return null;
  return (
    <img src={srcs[i]} alt="" loading="lazy" onError={() => setI(n => n + 1)}
      className={dim ? "bam-learn-dim" : undefined}
      style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "cover", display: "block", ...style }}/>
  );
}

export default VideoThumb;
